import { IconProps } from '.';

const CalendarIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0833 7.91675V10.0001H14.5833V7.91675H25.4167V10.0001H27.9167V7.91675H33.75V13.7501H6.25V7.91675H12.0833ZM14.5833 5.41675H25.4167V1.66675H27.9167V5.41675H35C35.6904 5.41675 36.25 5.97639 36.25 6.66675V33.3334C36.25 34.0238 35.6904 34.5834 35 34.5834H5C4.30964 34.5834 3.75 34.0238 3.75 33.3334V6.66675C3.75 5.97639 4.30964 5.41675 5 5.41675H12.0833V1.66675H14.5833V5.41675ZM6.25 32.0834V16.2501H33.75V32.0834H6.25ZM20.1325 29.1255L27.6325 19.9588L25.6976 18.3757L19.2677 26.2345L16.8718 22.6406L14.7917 24.0273L18.125 29.0273C18.3449 29.3571 18.7081 29.5631 19.104 29.5825C19.4999 29.6018 19.8815 29.4323 20.1325 29.1255Z"
        fill={color}
      />
    </svg>
  );
};

export default CalendarIcon;
